import React from 'react';
import clsx from 'clsx';
import { styled, Paper, SxProps, Theme } from '@mui/material';

const classes = {
    active: 'TotalsBox-active',
    clickable: 'TotalsBox-clickable'
};

const StyledPaper = styled(Paper)(({ theme }) => ({
    display: 'flex',
    padding: theme.spacing(2),
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    height: '100%',
    minHeight: '112px',
    background: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    [`&.${classes.clickable}`]: {
        cursor: 'pointer',
        background: theme.palette.grey[100],
        '&:hover': {
            boxShadow: theme.shadows[3]
        }
    },
    [`&.${classes.active}`]: {
        cursor: 'default',
        background: theme.palette.background.paper,
        boxShadow: theme.shadows[1]
    }
}));

interface MetricCardProps {
    active?: boolean;
    clickable?: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    sx?: SxProps<Theme>;
}

export const MetricCard: React.FC<MetricCardProps> = ({
    active = false,
    clickable = false,
    onClick,
    children,
    sx
}) => (
    <StyledPaper
        className={clsx({ [classes.clickable]: clickable, [classes.active]: active })}
        elevation={0}
        onClick={onClick}
        sx={sx}
    >
        {children}
    </StyledPaper>
);
